import React from "react";
import {
    View,
    Text,
    StyleSheet,
    TouchableOpacity,
    ImageBackground, Image, TextInput,

} from "react-native";
import {RFValue} from "react-native-responsive-fontsize";

import * as Linking from "expo-linking";

const Update = ({route})=>{

    const open = ()=>{
        // alert(route.params.link)
        Linking.openURL(route.params.link)
    }
    return (
        <View style={{flex : 1}}>
            <ImageBackground
                source={{uri:'https://metamax.network/public/appBg.jpg'}}
                resizeMode="cover" style={{flex : 1,justifyContent : 'center' , alignItems : 'center'}}>


                <Text style={styles.header}>
                    New Update receive
                </Text>
                <Text style={styles.text}>
                    {route.params.text}
                </Text>

                <TouchableOpacity
                    onPress={open}

                                   style={{justifyContent : 'center',width : '45%',alignItems : 'center', marginTop : RFValue(20)}}>
                    <View style={styles.btn2}>
                        <Text  style={styles.btntext}>Download </Text>
                    </View>
                </TouchableOpacity>



            </ImageBackground>
        </View>
    );
}

const styles = StyleSheet.create({
    header : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(25),
        padding : RFValue(25),

        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,


    },
    text : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'justify',
        fontSize : RFValue(15),
        padding : RFValue(25),
        // margin : RFValue(10),
        width : '80%',


        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,


    },
    btn2 : {

        borderWidth : 1,
        borderColor : 'transparent',
        width : '80%',
        margin : "auto",
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(5),
        borderRadius : RFValue(5),
        backgroundColor : '#009688'
    },
    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
        fontSize : RFValue(18),
    },
});

export default Update ;
